import {IntermediatePart} from "../../intermediatePart";

export default class FrontWall extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'front_wall';
    this.partName = 'Front Wall';
    this.translateId = "visualizer.bathroom.walls.front_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new FrontWall());
  }

}
